import { createUrlResolver, siteNames } from '@seek/melways-sites';
import React from 'react';

import type { ConfigOptions, ConfigUtils } from 'src/types';

const urlResolver = createUrlResolver({
  site: siteNames.employer.seek.au,
  language: 'en-AU',
  staging: false,
});

export const defaultConfig: ConfigOptions = {
  site: siteNames.employer.seek.au,
  environment: 'development',
  branch: 'unknown',
  brand: 'unknown',
  version: 'unknown',
  locale: 'en-AU',
  zone: 'anz-1',
};

export const defaultConfigUtils: ConfigUtils = {
  urlResolver: ({ path, language = 'en', product = 'employer' }) =>
    urlResolver({ path, language, product }),
};

export const ConfigContext = React.createContext<ConfigOptions & ConfigUtils>({
  ...defaultConfig,
  ...defaultConfigUtils,
});

export const useConfig = () => React.useContext(ConfigContext);
